<template>
    <RufizSelect v-model="value" :propVal="this.propvalue" :disabled="disabled" :options="object" placeholder="Select" />
</template>
<script>
 
import RufizSelect from '@/project/Components/RufizSelect.vue';

export default {
    components: {
        RufizSelect
    },
    props: {
        propvalue: Number,
        disabled: Boolean
    },
    data() {
        return {
            value: this.propvalue,
            object: []
        }
    },
    watch: {
        value() {
            this.$emit('change-value', this.value)
        }
    },
    mounted() {
      //None
    } 
}
</script>
<style>
.el-select-dropdown__item .option-content {
    white-space: normal !important;
    word-wrap: break-word;
}

.el-select-dropdown__item .option-content {
    white-space: normal !important;
}
</style>